var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 7,
    viewBox: "0 0 17 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5549_64634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27974 0.395508H0.797852V6.8774H7.27974V0.395508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5549_64634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06401 0.395508C3.74567 3.08549 3.48784 3.34333 0.797852 3.66166C0.803613 3.66238 0.808651 3.6631 0.814413 3.66382C3.48855 3.98143 3.74639 4.24359 4.06401 6.92781C4.38234 4.23783 4.64017 3.97999 7.33015 3.66166C4.64089 3.34333 4.38234 3.08549 4.06401 0.395508Z",
    fill: "white",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5549_64634",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 8,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0219 0.395508H9.54004V6.8774H16.0219V0.395508Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5549_64634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8062 0.395508C12.4879 3.08549 12.23 3.34333 9.54004 3.66166C9.5458 3.66238 9.55085 3.6631 9.55661 3.66382C12.2308 3.98143 12.4886 4.24359 12.8062 6.92781C13.1245 4.23783 13.3824 3.97999 16.0723 3.66166C13.3831 3.34333 13.1245 3.08549 12.8062 0.395508Z",
    fill: "white",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIcon);
export default __webpack_public_path__ + "static/media/top-icon.61da37c27490c1e7c63005fd068a8cc4.svg";
export { ForwardRef as ReactComponent };